import * as types from '../actions/ActionTypes';
import initialState from './initialState';
import {PUT_REPRESENTATIVE, SET_REPRESENTATIVES} from "../actions/RepresentativesActions";


export default function (state = initialState.representatives, action) {
    switch (action.type) {
    case types.GET_REPRESENTATIVE_SUCCESS:
    case types.GET_CUSTOMER_REPRESENTATIVES_SUCCESS:
    case types.GET_REPRESENTATIVES_SUCCESS: {
        return action.payload;
    }
    case PUT_REPRESENTATIVE:{
        const {data} = action.payload;
        return state.map(item => (data.id === item.id ? {...item, ...data} : { ...item}));
    }
    case SET_REPRESENTATIVES: {
        const {data = []} = action.payload;
        return data
    }
    default:
        return state;
    }
}
